function tabs () {
    /**
     * Настройка табов FAQ
     */
    const faqBtn = document.querySelectorAll('.home__faq-title');

    if(faqBtn.length > 0) {
        faqBtn.forEach(el=> {
            el.addEventListener('click', function() {
                const parent = this.closest('.home__faq-item');
                const faqDescr = parent.querySelector('.home__faq-descr');
                const faqTxtH = parent.querySelector('.home__faq-txt').offsetHeight;

                this.classList.toggle('active');
                
                this.classList.contains('active') ? faqDescr.style.height = faqTxtH + 'px' : faqDescr.style.height = 0;
            });
        });
    }
}

export default tabs;